var _rect, _path, _path2, _g, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmpty = function SvgEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 120,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.667,
    height: 98.667,
    fill: "url(#empty_svg__a)",
    rx: 1.333,
    transform: "matrix(-1 0 0 1 94.667 10.667)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty_svg__b)",
    d: "M46.667 53.333H52v25.333h-5.333z",
    opacity: 0.41,
    transform: "rotate(180 46.667 53.333)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty_svg__c)",
    d: "M0 0h5.333v20H0z",
    opacity: 0.41,
    transform: "matrix(-1 0 0 1 118.667 66.667)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#16171A",
    d: "M62.063 40 108 50.31c-.244 5.132-1.534 13.398-4.625 21.091-2.838 7.063-7.195 13.642-13.656 16.873-4.774 2.386-10.354 3.437-15.938 3.673-10.206.432-20.428-1.856-25.781-3.673z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ADB1B8",
    d: "M73.781 91.947c5.584-.236 11.164-1.287 15.938-3.673 6.461-3.23 10.818-9.81 13.656-16.873M73.781 91.947C63.575 92.379 53.353 90.09 48 88.274L62.063 40 108 50.31c-.244 5.132-1.534 13.398-4.625 21.091M73.781 91.947l.982-.809a39.24 39.24 0 0 0 11.206-15.05c6.09 0 12.146-1.617 17.406-4.687"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F7A600",
    d: "m65.436 56.844 25.334 5.333m-26.667 1.334 25.333 5.333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__a",
    x1: 10.44,
    x2: 11.743,
    y1: 211.14,
    y2: 4.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#F7A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__b",
    x1: 48.482,
    x2: 48.976,
    y1: 107.545,
    y2: 54.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#F7A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__c",
    x1: 1.816,
    x2: 2.124,
    y1: 42.799,
    y2: 1.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#F7A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty_svg__d",
    width: 61.133,
    height: 53.091,
    x: 47.386,
    y: 39.409,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.667,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.672065 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_27622_725"
  })))));
};
export default SvgEmpty;